import React, { useEffect, useState } from 'react';
import LayoffModal from './LayoffModal';
import { useCancelLayoff } from './useLayoff';
import styles from './layoff.module.scss';

const CancelLayoffModal = ({ layoff, onClose }) => {
  const [reason, setReason] = useState('');
  const [tried, setTried] = useState(false);
  const cancelLayoff = useCancelLayoff({ onSuccess: onClose });

  useEffect(() => {
    setReason('');
    setTried(false);
  }, [layoff?.hash]);

  const invalid = reason.trim().length < 3;

  const submit = () => {
    setTried(true);
    if (!invalid) {
      cancelLayoff.mutate({ hash: layoff.hash, reason: reason.trim() });
    }
  };

  return (
    <LayoffModal
      isOpen={!!layoff}
      title={`Cancel lay-off for ${layoff?.employee?.name ?? ''}?`}
      onClose={onClose}
    >
      <p>
        The lay-off notice is withdrawn. The employee and the signer(s) are told
        it was cancelled, and no one needs to sign it.
      </p>
      <label htmlFor='cancel-reason' className={styles.field_label}>
        Reason (required)
      </label>
      <textarea
        id='cancel-reason'
        rows={3}
        className={`${styles.textarea} ${tried && invalid ? styles.invalid : ''}`}
        value={reason}
        onChange={(event) => setReason(event.target.value)}
        placeholder='For example: sent to the wrong employee'
      />
      {tried && invalid && (
        <span className={styles.error_text}>
          Enter a reason to cancel this lay-off.
        </span>
      )}
      <div className={styles.modal_actions}>
        <button type='button' className='button grey' onClick={onClose}>
          Keep lay-off
        </button>
        <button
          type='button'
          className='button red'
          onClick={submit}
          disabled={cancelLayoff.isLoading}
        >
          {cancelLayoff.isLoading ? 'Cancelling...' : 'Cancel lay-off'}
        </button>
      </div>
    </LayoffModal>
  );
};

export default CancelLayoffModal;
